import SEOHead from '@/components/base/SEOHead';
import PageLayout from '@/components/feature/PageLayout';
import Breadcrumb from '@/components/base/Breadcrumb';
import { reviews } from '@/mocks/manga';

const aboutFaqs = [
  {
    question: '虫虫漫画是什么时候成立的？',
    answer: '虫虫漫画成立于2020年，经过多年的发展，已经成为国内领先的免费在线漫画阅读平台。我们致力于为漫画爱好者提供最新最全的漫画资源，让每个人都能享受阅读漫画的乐趣。',
  },
  {
    question: '虫虫漫画的漫画资源来源是什么？',
    answer: '虫虫漫画与多家正版漫画平台和出版社建立了合作关系，所有漫画资源均经过合法授权。我们严格尊重知识产权，致力于为读者提供正版、优质的漫画内容。',
  },
  {
    question: '如何联系虫虫漫画客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 contact@chongchongmanga.com，或在工作时间（周一至周日 9:00-21:00）使用在线客服功能。我们会在24小时内回复您的咨询。',
  },
  {
    question: '虫虫漫画是否会推出APP？',
    answer: '虫虫漫画目前正在积极开发移动端APP，预计将在不久的将来与大家见面。当前您可以通过手机浏览器访问我们的网站，同样可以获得流畅的漫画阅读体验。',
  },
];

const aboutFaqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: aboutFaqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于虫虫漫画',
  description: '虫虫漫画是最新最全的免费在线漫画阅读平台，提供热血、恋爱、玄幻等各类漫画资源。了解我们的品牌故事、核心优势和联系方式。',
  about: {
    '@type': 'Organization',
    name: '虫虫漫画',
    description: '免费在线漫画阅读平台',
    url: 'https://www.chongchongmanga.com',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@chongchongmanga.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  },
};

export default function About() {
  return (
    <PageLayout>
      <SEOHead
        title="关于我们"
        description="了解虫虫漫画的品牌故事、核心优势和联系方式。虫虫漫画是最新最全的免费在线漫画阅读平台，致力于为漫画爱好者提供优质的阅读体验。"
        keywords="虫虫漫画,关于虫虫漫画,漫画平台介绍,免费漫画平台,在线漫画阅读"
        canonicalUrl="https://www.chongchongmanga.com/about"
        schema={aboutSchema}
      />

      <div className="pt-16">
        {/* Page Header */}
        <section className="bg-background-100 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="pb-8">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                关于虫虫漫画
              </h1>
              <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-2xl">
                最新最全的免费在线漫画阅读平台，数百万漫画爱好者的共同选择
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  品牌故事
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  虫虫漫画诞生于2020年，由一群热爱漫画的年轻人创立。我们怀揣着"让每个人都能免费阅读优质漫画"的初心，从零开始打造了这个平台。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  经过多年的发展，虫虫漫画已经从一个小众平台成长为国内领先的在线漫画阅读网站。我们与多家正版漫画平台建立了合作关系，为读者提供了超过十万部优质漫画资源。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  我们始终坚持"免费、全面、及时"的服务理念，每日同步更新最新漫画章节，让漫画爱好者能够第一时间阅读到心仪的作品。
                </p>
              </div>
              <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20illustration%20of%20a%20cozy%20reading%20corner%20with%20comic%20books%20on%20wooden%20desk%2C%20soft%20natural%20light%20from%20window%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimal%20modern%20interior%20style%2C%20peaceful%20atmosphere%2C%20flat%20illustration%20with%20subtle%20textures&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="虫虫漫画品牌故事"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core Advantages */}
        <section className="py-10 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                核心优势
              </h2>
              <p className="text-sm text-foreground-500 mt-2">为什么选择虫虫漫画</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2">海量资源</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  超过十万部漫画资源，涵盖热血、恋爱、玄幻、搞笑、悬疑等多种类型，满足不同读者的阅读需求。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 bg-accent-100 rounded-full flex items-center justify-center">
                  <i className="ri-flashlight-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2">极速更新</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  与各大漫画平台保持同步更新，热门漫画24小时内同步上线，让你永远比其他人更早看到最新章节。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 bg-secondary-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2">完全免费</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  所有漫画内容永久免费阅读，无需付费订阅。我们致力于让每个人都能无障碍地享受漫画的乐趣。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-device-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2">多端适配</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  完美支持电脑、平板和手机阅读，响应式设计确保在任何设备上都能获得流畅舒适的阅读体验。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Reader Reviews */}
        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                口碑评价
              </h2>
              <p className="text-sm text-foreground-500 mt-2">来自漫画爱好者的真实声音</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {reviews.map((review) => (
                <div key={review.id} className="bg-background-100 rounded-lg p-5 border border-background-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center text-accent-700 font-bold text-sm">
                      {review.username.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.username}</p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`ri-star-fill text-xs ${i < review.rating ? 'text-yellow-500' : 'text-foreground-300'}`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-10 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 mt-2">有任何问题或建议，欢迎随时联系我们</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                <p className="text-sm text-foreground-600">contact@chongchongmanga.com</p>
                <p className="text-xs text-foreground-400 mt-1">24小时内回复</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-full flex items-center justify-center">
                  <i className="ri-customer-service-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-1">在线客服</h3>
                <p className="text-sm text-foreground-600">周一至周日</p>
                <p className="text-xs text-foreground-400 mt-1">9:00 - 21:00</p>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200 text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-secondary-100 rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-600">中国·杭州</p>
                <p className="text-xs text-foreground-400 mt-1">互联网漫画产业基地</p>
              </div>
            </div>
          </div>
        </section>

        {/* About FAQ */}
        <section className="py-10 md:py-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                常见问题
              </h2>
            </div>
            <div className="space-y-3">
              {aboutFaqs.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-lg border border-background-200">
                  <summary className="flex items-center justify-between p-4 cursor-pointer list-none">
                    <h4 className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</h4>
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                      <i className="ri-add-line text-sm group-open:hidden"></i>
                      <i className="ri-subtract-line text-sm hidden group-open:block text-primary-600"></i>
                    </span>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutFaqSchema) }}
            />
          </div>
        </section>
      </div>
    </PageLayout>
  );
}